import React, { useState } from 'react'
import Footer from '../../components/Footer/Footer'
import Hero from '../../components/HeroSection/Index'
import Navbar from '../../components/Navbar/Index'
import Sidebar from '../../components/Sidebar/Index'
import Contact from './Contact'
import KontakDiv from '../../components/logo/KontakDiv'
import Portofolio from './portofolio/Portofolio'
import BgDark from '../../components/Background/Index.'
import MySkill from '../../components/Skill.js/Index.'

const Home = () => {
    const [isOpen,setOpen] = useState(false)
    const toggle = () => {
        setOpen(!isOpen)
    }
    return (
        <div id="home">
            <KontakDiv/>
            <Sidebar isOpen={isOpen} toggle={toggle}/>
            <Navbar toggle={toggle}/>
            <Hero/>
            <BgDark />
            <MySkill/>
            <Portofolio/>
            <Contact/>
            <Footer/>
        </div>
    )
}

export default Home
